import {
    CSSProperties,
    ChangeEventHandler,
    KeyboardEventHandler,
    RefObject,
    useContext,
    // useRef,
    ReactNode,
    useState,
} from "react";
import { emailLogo, phoneLogo, calenderIcon } from "../../../../assets/assetsSVG";
import QuestContext from "../../../../components/QuestWrapper";

import "./css/InputModule.css";
import { useOnboarding } from "../modular/OnboardingContext";

const LogoType = {
    email: emailLogo,
    phone: phoneLogo,
    text: () => <></>,
    number: phoneLogo,
    date: calenderIcon,
};

export type logoType = keyof typeof LogoType;

interface PropType {
    placeholder?: string;
    type?: keyof typeof LogoType;
    style?: CSSProperties | undefined;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
    iconColor?: string;
    value?: string;
    ref?: RefObject<HTMLInputElement>;
    logoPosition?: "left" | "right" | "both";
    required?: boolean;
    regexKey?: string | undefined,
    regexMessage?: string,
    name?: string;
    key?: string | number | undefined;

    textErrorStyle?: CSSProperties | undefined | any;
    errorText?: string;
    validateInputRegex?: (validated: boolean) => void
}

export const TextInputModule = ({
    placeholder,
    type = "text",
    onChange,
    onKeyUp,
    onKeyDown,
    iconColor,
    value,
    ref,
    logoPosition = "right",
    textErrorStyle,
    errorText,
    required,
    regexKey = "",
    regexMessage = "",
    name,
    key,
    style,
    validateInputRegex = () => { }
}: PropType) => {
    // const { themeConfig } = useContext(QuestContext.Context);
    const { themeManager } = useOnboarding()
    const [isValidText, setIsValidText] = useState(true);
    const fallbackPattern = /^.+$/;

    const isValidRegex = (pattern: string | undefined): boolean => {
        try {
            new RegExp(pattern || '')
            return true;
        } catch (e) {
            return false;
        }
    };

    const textRegex = !regexKey ? fallbackPattern : isValidRegex(regexKey) ? new RegExp(regexKey) : fallbackPattern;

    const validateText = (inputValue: string) => {
        if (inputValue) {
            setIsValidText(textRegex.test(inputValue));
            validateInputRegex(textRegex.test(inputValue));
        } else {
            setIsValidText(true);
            validateInputRegex(true);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateText(inputValue);
        }
        if (onChange) {
            onChange(e);
        }
    };

    const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateText(inputValue);
        }
    };

    return (
        <>
            <div className="q_input_cont" style={style}>
                {/* {(logoPosition == "left" || logoPosition == "both") &&
                    LogoType[""](iconColor || "#B9B9B9")} */}
                <input
                    type={"text"}
                    name={name}
                    placeholder={placeholder}
                    className="q_input_main_cont"
                    onChange={handleInputChange}
                    onKeyUp={onKeyUp}
                    onKeyDown={onKeyDown}
                    // value={value}
                    defaultValue={value}
                    ref={ref}
                    onBlur={handleInputBlur}
                    onWheel={(event) => {
                        event.currentTarget.blur();
                    }}
                    style={{
                        fontFamily: themeManager?.getFontFamily() ||
                         "'Figtree', sans-serif",
                        color: style?.color,
                    }}
                    required={required}
                    pattern={(!!regexKey) ? textRegex.source : undefined}
                    key={key}
                />
                {/* {(logoPosition == "right" || logoPosition == "both") &&
                    LogoType["text"](iconColor || "#B9B9B9")} */}
            </div>
            {(!!regexKey) && !isValidText && (
                <span style={textErrorStyle} className="q-input-error-message">
                    {regexMessage || errorText}
                </span>
            )}
        </>
    );
};
